
interface ClearCookiesOptions {
  paths?: string[];
  domains?: string[];
  secure?: boolean;
}
/** Elimina las cookies visibles probando las rutas y dominios configurados. */
export const clearAllCookies = (options: ClearCookiesOptions = {}): void => {
  const {
    paths = ['/'],
    domains = [window.location.hostname, `.${window.location.hostname}`],
    secure = window.location.protocol === 'https:'
  } = options;

  const cookies = document.cookie.split(';');

  cookies.forEach((cookie) => {
    const cookieName = cookie.split('=')[0].trim();
    
    if (!cookieName) return;

    paths.forEach((path) => {
      domains.forEach((domain) => {
        deleteCookie(cookieName, { path, domain, secure });
      });
    });
  });
};

interface DeleteCookieOptions {
  path?: string;
  domain?: string;
  secure?: boolean;
}
/** Expira una cookie concreta para una combinación de ruta y dominio. */
export const deleteCookie = (
  name: string,
  options: DeleteCookieOptions = {}
): void => {
  const { path = '/', domain, secure = false } = options;

  const cookieParts = [
    `${encodeURIComponent(name)}=`,
    'expires=Thu, 01 Jan 1970 00:00:00 GMT',
    `path=${path}`
  ];

  if (domain) {
    cookieParts.push(`domain=${domain}`);
  }

  if (secure) {
    cookieParts.push('secure');
  }

  document.cookie = cookieParts.join("; ");
};

/** Convierte un texto numérico a entero o devuelve el valor predeterminado. */
export const tryParseInt = (str, defaultValue = 0): number => {
  var retValue = defaultValue;
  if (str && str.length > 0) {
    if (!isNaN(str)) {
      retValue = parseInt(str);
    }
  }
  return retValue;
};
const MILLISECONDS_PER_MINUTE = 60000; // 60,000 ms = 60 seconds.

/** Convierte una cantidad de minutos a milisegundos para los temporizadores. */
export const setTimeoutMin2Ms = (num): number => {
  var timeoutMins = tryParseInt(num);
  if (timeoutMins > 0) {
    return timeoutMins * MILLISECONDS_PER_MINUTE;
  }
  return 0;
};
